<template>
    <div>
        <b-card
                :header="title"
                header-text-variant="white"
                header-bg-variant="info"
        >
            <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">
                <b-row>
                    <b-col xl="12">
                        <b-form-group label="Participants">
                            {{ call.participants[0].name }}
                        </b-form-group>

                        <b-form-group label="Subject" label-for="subject">
                            <b-form-select
                                    id="subject"
                                    name="subject"
                                    v-model="form.subject"
                            >
                                <option value="">-- Choose Subject --</option>
                                <option v-for="item in subjects" :value="item.subject" :key="item.id">{{ item.subject }}</option>
                            </b-form-select>
                            <input-help :form="form" field="subject" text=""></input-help>
                        </b-form-group>

                        <b-form-group label="Description" label-for="description">
                            <b-textarea id="description" :rows="10" v-model="form.description" />
                            <input-help :form="form" field="description" text="" />
                        </b-form-group>

                        <b-form-group label="Actions / Next Steps" label-for="actions">
                            <b-textarea id="actions" :rows="10" v-model="form.actions" />
                            <input-help :form="form" field="actions" text="" />
                        </b-form-group>

                        <b-form-group label="LTCG Admin" label-for="office_user_id">
                            {{ call.office_user.name}}
                        </b-form-group>

                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12">
                        <b-button v-if="call.id" variant="success" type="submit">Save Changes</b-button>
                        <b-button v-else variant="success" type="submit">Submit</b-button>
                    </b-col>
                </b-row>
            </form>
        </b-card>
    </div>
</template>

<script>
    import UsesRole from "../../../mixins/UsesRole";

    export default {
        mixins: [UsesRole],

        props: {
            call: {
                type: Object,
                default() { return {} },
            },
            subjects: {
                type: Array,
                default() { return [] },
            },
            authUser: {
                type: Number,
                default() { return -1 },
            }
        },

        data() {
            return {
                admins: [],
                participants: [],
                form: new Form({
                    description: this.call.id ? this.call.description : '',
                    actions: this.call.id ? this.call.actions : '',
                    participants: this.call.id ? this.call.participants.map(obj => obj.id) : [],
                    office_user_id: this.call.id ? this.call.office_user_id : this.authUser,
                    subject: this.call.id ? this.call.subject : '',
                }),
            }
        },

        computed: {
            title() {
                if (this.call.id) {
                    return 'Edit Support Call Log';
                }

                return 'Create New Support Call Log';
            },

            url() {
                if (this.call.id) {
                    return `/${this.controller}/support-calls/${this.call.id}`;
                }

                return `/${this.controller}/support-calls`;
            }
        },

        methods: {
            submit() {
                this.form.submit(this.call.id ? 'patch' : 'post', this.url)
                .then( ({ data }) => {

                })
            },

            fetchAdmins() {
                axios.get(`/${this.controller}/specialists`)
                .then( ({ data }) => {
                    this.admins = data;
                })
                .catch(e => {
                    this.admins = [];
                })
            },

            participantExists(user_id) {
                return this.participants.findIndex(obj => obj.id == user_id) >= 0;
            },

            addParticipant(user) {
                if (this.participantExists(user.id)) {
                    return;
                }

                this.participants.push(user);
                this.form.participants.push(user.id);
            },

            removeParticipant(user_id) {
                this.participants = this.participants.filter(obj => obj.id != user_id);
                this.form.participants = this.participants.map(obj => obj.id);
            }
        },

        mounted() {
            this.fetchAdmins();
        },

        watch: {
            call(newVal, oldVal) {
                this.participants = newVal.participants;
            },
        },
    }
</script>

<style>

</style>